// extracted by mini-css-extract-plugin
export var externalLink = "_bg-0";
export var internalLinkLabel = "_bg-1";